// Public asset paths (served from /app/frontend/public/assets/)
// Using PUBLIC_URL so the offline build (homepage=".") works with file:// protocol
const BASE = process.env.PUBLIC_URL || "";
const P = (f) => `${BASE}/assets/products/${f}`;
const B = (f) => `${BASE}/assets/brands/${f}`;
const G = (f) => `${BASE}/assets/gallery/${f}`;

export const SITE = {
  name: "Giriraj Enterprises",
  short: "Giriraj",
  established: "15.08.2025",
  city: "Nanded",
  region: "Maharashtra, India",
  address: "Beside Ardapurkar Hospital, Gurudwara Road, Nanded – 431601",
  phone: "+91 75882 32126",
  phoneRaw: "917588232126",
  contactPerson: "Kunal Mundada",
  mapsLink: "https://maps.app.goo.gl/TZFUucPro4fFCLpq6",
  mapsEmbed:
    "https://www.google.com/maps?q=Giriraj+Enterprises+Nanded&ll=19.151875,77.3155008&z=17&output=embed",
  waIntro:
    "Hello%20Giriraj%20Enterprises!%20I%27m%20interested%20in%20your%20electrical%20products.",
  social: {
    instagram: "https://www.instagram.com/_giriraj_enterprises_?igsh=MXVydGt2NXAyNHhqZA==",
    // Google reviews open via the Maps deep-link
    googleReviews: "https://maps.app.goo.gl/TZFUucPro4fFCLpq6",
  },
  hours: [
    { day: "Mon – Sat", time: "10:00 AM – 9:00 PM" },
    { day: "Sunday", time: "10:30 AM – 4:00 PM" },
  ],
  stats: [
    { k: "10+", v: "Brands stocked" },
    { k: "1K+", v: "Happy customers" },
    { k: "1000+", v: "SKUs in stock" },
  ],
  categories: [
    { id: "ceiling-fan", n: "01", title: "Ceiling Fan", tag: "Airflow", sub: "Energy-efficient fans for every room size.", img: P("ceiling-fan.jpeg") },
    { id: "pedestal-fan", n: "02", title: "Pedestal Fan", tag: "Airflow", sub: "Height-adjustable fans for halls & large spaces.", img: P("pedestal-fan.jpeg") },
    { id: "wall-fan", n: "03", title: "Wall Fan", tag: "Airflow", sub: "Space-saving oscillating fans for shops & kitchens.", img: P("wall-fan.jpeg") },
    { id: "exhaust-fan", n: "04", title: "Exhaust & Heavy-Duty Fan", tag: "Airflow", sub: "High-airflow fans for bathrooms, kitchens & industrial use.", img: P("exhaust-fan.jpeg") },
    { id: "switches", n: "05", title: "Switches & Sockets", tag: "Control", sub: "Anchor by Panasonic — India's most trusted.", img: P("switches-sockets.jpeg") },
    { id: "conduits", n: "06", title: "Conduits & Pipe", tag: "Routing", sub: "PVC conduits & pipes for safe wire routing.", img: P("conduits-pipe.jpeg") },
    { id: "cable-tray", n: "07", title: "Cable Tray", tag: "Routing", sub: "Heavy-duty trays for cable management.", img: P("cable-tray.jpeg") },
    { id: "cob-linear", n: "08", title: "COBs & Linear Lights", tag: "Light", sub: "High-output chip-on-board LED fixtures.", img: P("cobs-linear.jpeg") },
    { id: "magnetic-track", n: "09", title: "Magnetic & Track Light", tag: "Light", sub: "Directional track lighting for showrooms.", img: P("magnetic-track.jpeg") },
    { id: "strip-drivers", n: "10", title: "Strip Light & Drivers", tag: "Light", sub: "Flexible LED strips with compatible drivers.", img: P("strip-drivers.jpeg") },
    { id: "flood-street", n: "11", title: "Flood & Street Light", tag: "Light", sub: "Outdoor high-power LED solutions.", img: P("flood-street.jpeg") },
    { id: "rope-light", n: "12", title: "Rope Light", tag: "Light", sub: "Decorative flexible rope lights for ambience.", img: P("rope-light.jpeg") },
    { id: "profile-light", n: "13", title: "Profile Light", tag: "Light", sub: "Aluminium profile LEDs for modern interiors.", img: P("profile-light.jpeg") },
    { id: "bulb-extension", n: "14", title: "Bulb & Extension Box", tag: "Light", sub: "LED bulbs and multi-socket extension boards.", img: P("bulb-extension.jpeg") },
    { id: "spike-bulkhead", n: "15", title: "Spike LED & Bulkhead", tag: "Outdoor", sub: "Spike garden lights and bulkhead fittings.", img: P("spike-bulkhead.jpeg") },
    { id: "wires", n: "16", title: "Wires & Cables", tag: "Current", sub: "ISI-marked fire-resistant wires — all gauges.", img: P("wires-cables.jpeg") },
    { id: "mcbs", n: "17", title: "MCBs & DB Boxes", tag: "Safety", sub: "Circuit breakers and distribution boards.", img: P("mcbs-db.jpeg") },
    { id: "appliances", n: "18", title: "Dry Iron & Heater", tag: "Home", sub: "Reliable home appliances from trusted brands.", img: P("dry-iron-heater.jpeg") },
  ],
  brands: [
    { name: "Anchor", sub: "by Panasonic", tag: "Switches & Sockets", featured: true, badge: "Authorised Dealer", logo: B("anchor.png") },
    { name: "Havells", tag: "Fans · Wires · MCBs", logo: B("havells.svg") },
    { name: "Orient", tag: "Fans · Lighting", logo: B("orient.png") },
    { name: "Bajaj", tag: "Fans · Lighting", logo: B("bajaj.png") },
    { name: "Crompton", tag: "Fans · Pumps", logo: B("crompton.png") },
    { name: "Legrand", tag: "Switches · MCBs", logo: B("legrand.png") },
    { name: "Ledvance", sub: "Osram", tag: "Bulbs · Battens", logo: B("ledvance.png") },
    { name: "Appelite", tag: "COBs · Strip · Drivers", logo: B("appelite.png") },
    { name: "Pride", tag: "Flood · Panels · Bulkhead", logo: B("pride.png") },
    { name: "Schneider", sub: "Electric", tag: "MCBs · DB Boxes", logo: B("schneider.png") },
    { name: "Finolex", tag: "Wires · Cables", logo: B("finolex.png") },
    { name: "Almonard", tag: "Industrial Fans", logo: B("almonard.png") },
    { name: "Lauritz Knudsen", tag: "MCBs · Switches", logo: B("lk.png") },
  ],
  whyUs: [
    { n: "01", title: "100% Genuine Products", body: "Har product brand-authorised aur warranty-backed. No duplicates, no compromise." },
    { n: "02", title: "1000+ SKUs in Stock", body: "Fans se lekar MCBs tak — sab kuch ek hi jagah. Baar-baar aana nahi padega." },
    { n: "03", title: "Expert Guidance", body: "Sahi product choose karne mein help karte hain — ghar ho ya commercial project." },
    { n: "04", title: "Best Price, Guaranteed", body: "Competitive pricing, no hidden costs. Bulk orders pe special rates milte hain." },
    { n: "05", title: "Authorised Anchor Dealer", body: "Anchor by Panasonic ka official dealer — India ka #1 switch brand seedha aapke paas." },
    { n: "06", title: "Fast WhatsApp Support", body: "Koi bhi query — WhatsApp karo, jaldi reply milega. Aane se pehle stock check kar lo." },
  ],
  gallery: [
    { title: "Our Store", sub: "Gurudwara Road, Nanded", img: G("shop-front.jpeg") },
    { title: "Premium Interior", sub: "Curated for browsing", img: G("interior.jpeg") },
    { title: "Our Brands Wall", sub: "13 trusted partners", img: G("brands-wall.jpeg") },
    { title: "Massive Stock", sub: "1000+ SKUs in-store", img: G("stock.jpeg") },
    { title: "Finolex Cables", sub: "Always available", img: G("finolex-stock.jpeg") },
  ],
};
